export enum ModuleCategoryEnum {
  WorkOrders = 'WorkOrders',
  BillingPayments = 'BillingPayments',
  VisitorManagement = 'VisitorManagement',
  AccessManagement = 'AccessManagement',
  Inspections = 'Inspections',
}
